/* eslint-disable */
const getDigitPhone = (phone) => phone.replace(/[^0-9]/g, '');

export default getDigitPhone;

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
};

// Function to process incoming data from server for display in form
// Accepts different formats: "+1-223-344-5566", "1231231230", "2233445566"
// Returns "(223) 344-5566" for mask (___) ___-____
export const formatPhoneForDisplay = (phoneString) => {
  if (!phoneString) return '';

  // Remove all non-digit characters
  const cleaned = phoneString.replace(/\D/g, '');

  // Check different length variants
  let phoneDigits = '';

  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // Number with country code: "12233445566" -> "2233445566"
    phoneDigits = cleaned.substring(1);
  } else if (cleaned.length === 10) {
    // Number without country code: "2233445566"
    phoneDigits = cleaned;
  } else {
    // Invalid format, return as is
    return phoneString;
  }

  // Format to mask (223) 344-5566
  if (phoneDigits.length === 10) {
    return `(${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(3, 6)}-${phoneDigits.slice(6)}`;
  }

  return phoneString;
};

// Function to prepare data for sending to server
// Accepts "(223) 344-5566" or "+1 (223) 344-5566" from form
// Returns "2233445566" for server (digits only without +1)
export const formatPhoneForServer = (phoneString) => {
  if (!phoneString) return '';

  // Remove all non-digit characters
  const cleaned = phoneString.replace(/\D/g, '');

  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // Number with country code: "12233445566" -> "2233445566"
    return cleaned.substring(1);
  } else if (cleaned.length === 10) {
    // Number without country code: "2233445566"
    return cleaned;
  }

  // If length is not 10 or 11, return original string
  return phoneString;
};

// Function to display phone in info panel in format "+1 (XXX) XXX-XXXX"
// Accepts different formats from server and returns nicely formatted number
export const formatPhoneForInfoPanel = (phoneString) => {
  if (!phoneString) return '';

  // Remove all non-digit characters
  const cleaned = phoneString.replace(/\D/g, '');

  // Check different length variants
  let phoneDigits = '';

  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // Number with country code: "12233445566" -> "2233445566"
    phoneDigits = cleaned.substring(1);
  } else if (cleaned.length === 10) {
    // Number without country code: "2233445566"
    phoneDigits = cleaned;
  } else {
    // Invalid format, return as is
    return phoneString;
  }

  // Format to "+1 (223) 344-5566"
  if (phoneDigits.length === 10) {
    return `+1 (${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(3, 6)}-${phoneDigits.slice(6)}`;
  }

  return phoneString;
};
